import React from "react";
import clsx from "clsx";
import PT from "prop-types";
import AssetsUtil from "../util/AssetsUtil";
import {TopBarInfo} from "../util/components/TopBarInfo";

const WonkyButton = require("./WonkyButton");

import * as styles from "./styles/NavButtonTooltip.module.css";

export type InfoModal = {
	type: "unlock";
	extra: string;
	iconName: string;
};

type NavButtonTooltipProps = InfoModal & {
	onClose?: () => void;
};

function NavButtonTooltip({
	iconName,
	type,
	extra,
	onClose,
}: NavButtonTooltipProps) {
	const modalImage = AssetsUtil.getModal("help-modal");

	return (
		<div className={clsx(styles?.[type + "Blurb"])}>
			<img src={modalImage} className={styles?.blurbBg} />
			<TopBarInfo
				styles={{
					blurbContent: styles?.blurbContent,
					blurbQ: styles?.blurbQ,
					blurbContentV: styles?.blurbContentV,
				}}
				iconName={iconName}
				type={type}
				extraInfo={extra}
			/>
			<WonkyButton
				className={styles.blurbButton}
				handleClick={onClose}
				buttonType={"gotit"}
			/>
		</div>
	);
}

NavButtonTooltip.propTypes = {
	iconName: PT.string,
	type: PT.string,
	extra: PT.string,
	onClose: PT.func,
};

export default NavButtonTooltip;
